import { clsx } from 'clsx'

interface GlassBoxProps {
  children: React.ReactNode
  className?: string
}

export function GlassBox({ children, className }: GlassBoxProps): React.JSX.Element {
  return (
    <div
      className="relative h-full"
      style={{
        borderRadius: '32px'
      }}
    >
      <div
        className="absolute inset-0"
        style={{
          borderRadius: '32px',
          backdropFilter: 'blur(6px)',
          background:
            'linear-gradient(128.8deg, rgba(var(--rgb-gray-100), 0.21) 31.4%, rgba(var(--rgb-gray-80), 0.21) 103.25%)'
        }}
      />
      <div className={clsx('relative', className)}>{children}</div>
    </div>
  )
}
